import React from 'react';
import '../../styles/sections.css';
import '../../styles/technologies.css';

const Technologies = () => {
  return (
          <section className="technologies-section">
        <div className="section-header">
          <h2>TECHNOLOGIES</h2>
          <div className="underline"></div>
        </div>
        <div className="technologies-content">
        <ul style={{ lineHeight: '1.8', paddingLeft: '1rem' }}>
          <li><strong>Frontend:</strong> React Native, Expo</li>
          <li><strong>Frontend Testing:</strong> Apple TestFlight</li>
          <li><strong>Backend:</strong> Go</li>
          <li><strong>Backend Infrastructure:</strong> AWS Lambda, API Gateway</li>
          <li><strong>Database:</strong> PostgreSQL (Neon)</li>
          <li><strong>Image Processing:</strong> AWS Rekognition</li>
          <li><strong>Image Storage:</strong> IPFS Pinata</li>
          <li><strong>Platform:</strong> iOS</li>
        </ul>
      </div>
    </section>
  );
};

export default Technologies;

